import { Component, Input, OnInit } from "@angular/core";
import { UserInfoService } from "./../services/user-info.service";
import { IUser } from "./../models/user.model";
import { Subscription } from "rxjs";
import { ZpDataService } from "./../services/zp-data.service";
import { FormTemplateService } from "./../services/form-template.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ILinkbox } from "./../models/linkbox.model";
import plantree from "../../assets/data/plan-tree.json";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { PreviousUrlService } from "../services/previous-url.service";
import { GetInfoAndPassService } from "../services/get-info-and-pass.service";
import { ThemeService } from "../theme/theme-service.service";

@Component({
  selector: "app-plan-review",
  templateUrl: "./plan-review.component.html",
  styleUrls: ["./plan-review.component.scss"],
})
export class PlanReviewComponent implements OnInit {
  public subscription: Subscription;
  public subscription2: Subscription;
  public myUser: IUser;
  public currentStep: string;
  public categoryContent: {} = {};
  public itemToDeleteId;
  public dataIsLoaded: boolean;
  public myFormTemplate: ILinkbox;
  public templateName = "my-assets";
  public collapseStatus = [];
  public emptySections: string[] = [];
  public categoryName = "Assets";
  public categoryDescription =
    "Plan Review lists out all the items in your plan, making it easy for you to update or delete your existing items as well as adding new ones to your plan.";
  public categoryIcon;
  public stepNumber = "1";
  public stepButtonText = "Next Step";
  public id: any;
  public hasPlan: any;
  public showSideNav;
  public Id;
  public planCategory: string;
  public sharedPlanClientId: any;
  public sectionName: any;
  public titleSection: string;
  public href: string;
  public getCategoryData: string;
  public previousLink: string;
  currentUrl: any;

  constructor(
    private ZpDataService: ZpDataService,
    private priviousUrl: PreviousUrlService,
    private getInfoAndPassService: GetInfoAndPassService,
    private userInfo: UserInfoService,
    private router: Router,
    private ftService: FormTemplateService,
    public themeService: ThemeService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.id = params.get("id");
      this.subscription = this.userInfo.getMessage().subscribe((user) => {
        this.myUser = JSON.parse(user);
        if (this.myUser.delegate) {
          if (this.id == this.myUser.delegate.clientId) {
            this.myUser = this.myUser.delegate;
            this.myUser = JSON.parse(user);
          }
        }
      });
    });
    this.getInfoAndPassService.accessRightSection.subscribe((data) => {
      this.getCategoryData = data;
    });
    this.getInfoAndPassService.accessRightSection.subscribe((data) => {
      this.currentUrl = data;
    });
  }

  async refresh() {
    await this.ZpDataService.revalidateCache();
    this.ZpDataService.changeMessage(
      JSON.stringify({ "cache revalidated": true })
    );
    this.href = this.router.url;
    switch (this.href) {
      case "/plan-review/assets":
        this.getCards("my-assets");
        this.setCategory("my-assets");
        break;
      case "/plan-review/debts":
        this.getCards("my-debts");
        this.setCategory("my-debts");
        break;
      case "/plan-review/dailyLife":
        this.getCards("my-daily-life");
        this.setCategory("my-daily-life");
        break;
      case "/plan-review/digitalLife":
        this.getCards("my-digital-life");
        this.setCategory("my-digital-life");
        break;
      case "/plan-review/wishes":
        this.getCards("my-wishes");
        this.setCategory("my-wishes");
        break;
    }
  }

  ngOnInit() {
    if (this.getCategoryData) {
      switch (this.getCategoryData) {
        case "categoryAssets":
          this.getCards("my-assets");
          this.setCategory("my-assets");
          break;
        case "categoryDebts":
          this.getCards("my-debts");
          this.setCategory("my-debts");
          break;
        case "categoryDailyLife":
          this.getCards("my-daily-life");
          this.setCategory("my-daily-life");
          break;
        case "categoryDigitalLife":
          this.getCards("my-digital-life");
          this.setCategory("my-digital-life");
          break;
        case "categoryWishes":
          this.getCards("my-wishes");
          this.setCategory("my-wishes");
          break;
      }
    } else {
      this.getCards("my-assets");
      this.setCategory("my-assets");
    }
    this.sideNavBarVisibilityService.hideSideNav = true;
  }

  setCategory(category) {
    this.currentStep = category;
    this.getCards(category);
    switch (category) {
      case "my-assets":
        this.stepNumber = "1";
        this.planCategory = "categoryAssets";
        this.router.navigate(["/plan-review/assets"]);
        break;
      case "my-debts":
        this.stepNumber = "2";
        this.planCategory = "categoryDebts";
        this.router.navigate(["/plan-review/debts"]);
        break;
      case "my-daily-life":
        this.stepNumber = "3";
        this.planCategory = "categoryDailyLife";
        this.router.navigate(["/plan-review/dailyLife"]);
        break;
      case "my-digital-life":
        this.stepNumber = "4";
        this.planCategory = "categoryDigitalLife";
        this.router.navigate(["/plan-review/digitalLife"]);
        break;
      case "my-wishes":
        this.stepNumber = "5";
        this.planCategory = "categoryWishes";
        this.router.navigate(["/plan-review/wishes"]);
        break;
    }
  }

  setCategoryByStep(step) {
    this.currentStep = step;
    this.stepButtonText = "Next Step";
    switch (step) {
      case "1":
        this.setCategory("my-debts");
        break;
      case "2":
        this.setCategory("my-daily-life");
        break;
      case "3":
        this.setCategory("my-digital-life");
        break;
      case "4":
        this.setCategory("my-wishes");
        break;
      case "5":
        this.router.navigate(["/home"]);
        this.stepButtonText = "Finished";
        break;
    }
  }

  async getCards(category) {
    this.dataIsLoaded = false;
    //await this.getMyUser();
    this.myFormTemplate = await this.ftService.getFormTemplateAsync(category);
    let group = {};
    let counter = 0;

    this.categoryContent["title"] = this.getTitle(
      this.myFormTemplate.sectionTitle
    );
    this.categoryName = this.categoryContent["title"];
    this.categoryContent["sections"] =
      await this.ZpDataService.getPlanCategoryInfo(
        this.myUser.Id,
        this.myFormTemplate.sectionTitle
      );
    if (!this.categoryContent["sections"]) {
      console.log("Error: mySections null");
    }
    let myCategory = plantree.find(
      (kk) => kk.planCategory == this.myFormTemplate.sectionTitle
    );
    this.categoryDescription = myCategory.categoryDescription;
    this.categoryContent["sections"].forEach((section) => {
      let mySectionCard: {} = section;

      let myCard = this.myFormTemplate.cards.find(
        (card) => card.title == mySectionCard["sectionName"]
      );
      this.sectionName = mySectionCard["sectionName"];
      section["viewUrl"] = myCard["viewurl"];
      section["editUrl"] = myCard["editurl"];
      section["addurl"] = myCard["addurl"];

      let description = myCategory.sectionObjects.find(
        (mySection) => mySection.section == section["sectionName"]
      ).sectionDescription;
      section["sectionDescription"] = description;
      var kkk = 0;
      //let myItemObject = plantree.find(kk => kk.sectionObjects["section"] == mysection)[0];
    });
    this.myFormTemplate.cards.forEach((card) => {
      let myContent = this.categoryContent["sections"].find(
        (section) => section["sectionName"] == card.title
      );
      this.titleSection = myContent;
      card["content"] = myContent;
      if (myContent) {
        card["content"] = myContent;
      } else {
        card["content"] = {
          items: [],
          itemTotal: 0,
          grandTotal: 0,
          sectionName: card.title,
          viewUrl: card["viewurl"],
          editUrl: card["editurl"],
          addurl: card["addurl"],
        };
      }
    });
    this.dataIsLoaded = true;
  }

  getTitle(templateName) {
    switch (templateName) {
      case "my assets":
        return "Assets";
      case "my debts":
        return "Debts";
      case "my daily life":
        return "Daily Life";
      case "my digital life":
        return "Digital Life";
      case "my wishes":
        return "Wishes";
    }
  }

  async showItemDeleted(choice) {
    this.refresh();
  }

  ngOnDestroy() {
    this.sideNavBarVisibilityService.hideSideNav = false;
    this.getCategoryData = null;
  }
}
